import React from 'react';
import { CalendarClock } from 'lucide-react';

interface ScheduledMessageFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const ScheduledMessageField: React.FC<ScheduledMessageFieldProps> = ({ value, onChange }) => {
  return (
    <div>
      <label className="flex items-center text-xs font-bold uppercase tracking-wider text-tinta mb-2">
        <CalendarClock className="h-4 w-4 mr-2 text-tinta-soft" />
        Mensagem WhatsApp (Sorteio Agendado)
      </label>
      <p className="text-xs text-tinta-soft italic mb-2">
        Mensagem enviada via WhatsApp quando o lead se cadastrar em sorteio agendado (opcional).
        Só será enviada se houver integração WhatsApp conectada.
      </p>
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Ex: Olá {nome}! Sua participação foi registrada com sucesso! O sorteio será realizado no dia {data_sorteio}. Boa sorte!"
        className="mt-1 block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors resize-y"
        rows={4}
        maxLength={1000}
      />
      <div className="flex justify-between mt-1">
        <p className="text-xs text-tinta-soft italic">
          Variáveis: {'{nome}'}, {'{whatsapp}'}, {'{data_sorteio}'}, {'{roda}'}
        </p>
        <p className="text-xs text-tinta-soft italic">
          {value?.length || 0}/1000
        </p>
      </div>
    </div>
  );
};

export default ScheduledMessageField;
